import styled from 'styled-components'

const Label = styled.label`
  font-family: Montserrat;
  letter-spacing: 2px;
`

export { Label }
